import { Signal } from 'micro-signals'
import { log } from 'utils/Logger'

const signals = {}
const show = ['boolean', 'string', 'number']

function getSignal(name) {
  return signals[name] = signals[name] || new Signal()
}

function onCustom(name, handler, trigger, once) {
  function wrap(payload) {
    if (String(payload) == trigger) {
      once && off(name, wrap)
      handler(payload)
    }
  }

  getSignal(name).add(wrap)
}

export const signal = {
  dispatch,
  off,
  on,
  once,
  promise,
}

function once(name, handler) {
  const [signal, custom] = name.split('|')
  if (custom) {
    onCustom(signal, handler, custom, true)
  }
  else {
    getSignal(signal).addOnce(handler)
  }
}

function on(name, handler) {
  const [signal, custom] = name.split('|')
  if (custom) {
    onCustom(signal, handler, custom, false)
  }
  else {
    getSignal(signal).add(handler)
  }
}

function promise(name) {
  return new Promise((resolve) => once(name, resolve))
}

function off(name, handler) {
  getSignal(name).remove(handler)
}

function dispatch(name, payload) {
  const details = show.includes(typeof payload) ? ` => ${payload}` : ''
  const [type] = name.split(':')
  log(`${name}${details}`, type)
  getSignal(name).dispatch(payload)
}
